var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanelTypeLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "440px",
    height: "672px",
    viewBox: "0 0 440 672",
    enableBackground: "new 0 0 440 672",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 72.8,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6,
    y: 95.9,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 10.9,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.7037,
    width: 404.4,
    height: 13
  })), /*#__PURE__*/React.createElement("rect", {
    x: 410.5,
    y: 8.9,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.7,
    y: 8.9,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9532,
    strokeMiterlimit: 10,
    d: "M248.7,650.4c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V28.8c0,0,4.9,0,15.1,0s15.1,0,15.1,0V650.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M218.5,651.4c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.2,6.8-13.2,6.8s-13.2-7.3-13.2-7.3V28.8h34.5V651.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M184,651.4c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.2,6.8-13.2,6.8s-13.2-7.3-13.2-7.3V28.8H184V651.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M149.5,651.4c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.2,6.8-13.2,6.8s-13.2-7.3-13.2-7.3V28.8h34.5V651.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M115,651.4c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.2,6.8-13.2,6.8s-13.2-7.3-13.2-7.3V28.8H115V651.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M80.5,651.4c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.2,6.8-13.2,6.8S46,651.4,46,651.4V28.8h34.5V651.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelTypeLeft);
export default __webpack_public_path__ + "static/media/panel_type_left.05435b0c1e8944cd6ff3892d3a162ef5.svg";
export { ForwardRef as ReactComponent };